/**
 * NECS company violation policy (Feb 2026 CEO directive).
 *
 * Six violation types agents can log against a residential unit, shown
 * verbatim to tenants in FAQs + weekly notification alerts so residents
 * know exactly what to avoid before their trash pickup window.
 */
export const NECS_VIOLATION_POLICY = [
  {
    key: 'open_bag',
    label: 'Open bag & loose trash',
    tenant_facing: 'Trash must be inside a closed, tied bag. Loose items or open bags are not accepted.',
    severity: 'medium',
  },
  {
    key: 'leaking_bag',
    label: 'Leaking bags',
    tenant_facing: 'Bags must be leak-free. Double-bag any wet or liquid contents.',
    severity: 'medium',
  },
  {
    key: 'bulky_items',
    label: 'Bulky items',
    tenant_facing: 'Furniture, mattresses, appliances, TVs and other bulky items require a scheduled bulk pickup. They cannot be left out at the trash bin.',
    severity: 'high',
  },
  {
    key: 'wrong_trashcan',
    label: 'Appropriate trashcan provided by NECS',
    tenant_facing: 'Use only the trashcan provided by NECS. Do not substitute buckets, boxes, or personal bins.',
    severity: 'low',
  },
  {
    key: 'boxes_not_broken',
    label: 'Boxes need to be broken down',
    tenant_facing: 'Cardboard boxes must be flattened before being placed in the bin.',
    severity: 'low',
  },
  {
    key: 'wrong_placement_time',
    label: 'Proper time trashcan placements',
    tenant_facing: 'Place your trashcan outside your door only within the announced pickup window. Do not put it out early or leave it out after collection.',
    severity: 'medium',
  },
];

/** Lookup by policy key. */
export const NECS_VIOLATION_BY_KEY = NECS_VIOLATION_POLICY.reduce((acc, v) => {
  acc[v.key] = v;
  return acc;
}, {});
